import { Component, inject } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { NgIf } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from '../../../core/auth/auth.service';
import { ReportApiService } from '../../../core/api/report-api.service';
import { LoggerService } from '../../../core/logging/logger.service';
import { firstValueFrom } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
@Component({
  selector: 'mfr-header',
  standalone: true,
  imports: [RouterLink, NgIf, MatMenuModule, MatButtonModule, MatDialogModule, MatDividerModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly logger = inject(LoggerService);
  private readonly reportApi = inject(ReportApiService);
  private readonly cdr = inject(ChangeDetectorRef);

  showLogoutConfirm = false;
  isPublishing = false;

  get isAdmin(): boolean {
    return this.auth.currentUser()?.isAdmin ?? false;
  }

  get displayName(): string {
    const u = this.auth.currentUser();
    return u ? (u.firstName || u.name || u.email) : '';
  }

  showLogoutPopup(): void {
    this.showLogoutConfirm = true;
  }

  cancelLogout(): void {
    this.showLogoutConfirm = false;
  }

  logout(): void {
    this.showLogoutConfirm = false;
    this.auth.logout();
  }

  async publishAll(): Promise<void> {
    if (!confirm('Are you sure you want to Publish?')) return;

    this.isPublishing = true;

    try {
      await firstValueFrom(this.reportApi.publishAll());
      alert('All Reports Published Successfully');
    }
    catch (err) {
      console.error(err);
      alert(err instanceof Error ? err.message : 'Something went wrong!');
    }
    finally {
      this.isPublishing = false;
      this.cdr.detectChanges();
    }
  }
}
